import { MembershipTier } from "@/types/api";

export interface TierDef {
  tier: MembershipTier;
  tr: string;
  en: string;
  priceMonthly: number | null; // null => custom/contact; commercial figures, not performance claims
  accent: string; // tailwind text
  chip: string; // tailwind bg/border
  ring: string;
  order: number;
  positionTr: string; // one-line positioning
  positionEn: string;
  featuresTr: string[];
  featuresEn: string[];
  highlight?: boolean;
}

export const TIERS: Record<MembershipTier, TierDef> = {
  FREE: {
    tier: "FREE", tr: "Ücretsiz", en: "Free", priceMonthly: 0, order: 0,
    accent: "text-muted-foreground", chip: "bg-white/5 border-white/10", ring: "ring-white/10",
    positionTr: "Keşif", positionEn: "Discovery",
    featuresTr: ["SDIP AI'ı keşfet", "Sınırlı canlı önizleme", "Sınırlı maç öncesi görünüm", "Genel performans özeti"],
    featuresEn: ["Explore SDIP AI", "Limited live preview", "Limited prematch view", "General performance summary"],
  },
  PRO: {
    tier: "PRO", tr: "Pro", en: "Pro", priceMonthly: null, order: 1,
    accent: "text-atlas-400", chip: "bg-atlas/10 border-atlas/25", ring: "ring-atlas/30",
    positionTr: "Tam zekâ erişimi", positionEn: "Full intelligence access",
    featuresTr: ["Canlı ve maç öncesini düzenli takip edenler için", "Gerçek zamanlı canlı sinyaller", "Tam maç öncesi erişim", "ATLAS Asistan", "Sinyal geçmişi ve sonuçlar", "Analiz Listem"],
    featuresEn: ["For those following live & prematch regularly", "Real-time live signals", "Full prematch access", "ATLAS assistant", "Signal history & results", "My Analysis list"],
    highlight: true,
  },
  ELITE: {
    tier: "ELITE", tr: "Elite", en: "Elite", priceMonthly: null, order: 2,
    accent: "text-atlas-300", chip: "bg-atlas/12 border-atlas/30", ring: "ring-atlas/40",
    positionTr: "Gelişmiş analiz ve öncelik", positionEn: "Advanced analysis & priority",
    featuresTr: ["Daha derin analiz ve öncelikli zekâ", "Tüm Pro özellikleri", "Öncelikli canlı bildirimler", "Gelişmiş momentum ve baskı analizi", "Lig ve örüntü analizi"],
    featuresEn: ["Deeper analysis and priority intelligence", "All Pro features", "Priority live notifications", "Advanced momentum & pressure", "League & pattern analysis"],
  },
  PREMIUM: {
    tier: "PREMIUM", tr: "Premium", en: "Premium", priceMonthly: null, order: 3,
    accent: "text-gold-400", chip: "bg-gold/10 border-gold/30", ring: "ring-gold/40",
    positionTr: "En hızlı ve en kişisel", positionEn: "Fastest & most personal",
    featuresTr: ["En hızlı ve en derin deneyim", "Tüm Elite özellikleri", "En düşük gecikmeli sinyaller", "Kişisel analiz paneli", "Tam geçmiş ve dışa aktarım"],
    featuresEn: ["The fastest, deepest experience", "All Elite features", "Lowest-latency signals", "Personal analysis panel", "Full history & export"],
    highlight: true,
  },
};

export const TIER_ORDER: MembershipTier[] = ["FREE", "PRO", "ELITE", "PREMIUM"];

export function tierRank(tier: MembershipTier | null | undefined): number {
  if (!tier) return -1;
  return TIERS[tier]?.order ?? -1;
}

// Entitlement helper: does `current` satisfy `required`?
export function hasEntitlement(current: MembershipTier | null | undefined, required: MembershipTier): boolean {
  return tierRank(current) >= tierRank(required);
}
